// Copyright 2005-2011 David Caldwell <david@porkrind.org> All rights reserved.

var dom = require('./dom'), URL=dom.URL;
var Prefs = require('./prefs');

var options;
var optionsdef = {};

function get_option(name, def, initial) {
    var val = initial;

    if (name in URL.param)
        val = URL.param[name];
    else if (name in Prefs.v)
        val = Prefs.v[name];
    else if (val === undefined)
        val = def.defawlt;

    if (def.kind == "boolean" && typeof(val) == "string")
        val = val.toLowerCase() == "false" || val == "0" ? false : true;
    if (def.kind == "number" && typeof(val) == "string")
        val = parseInt(val);
    return val;
}

function option_def(kind, defawlt) {
    var def = { kind:kind, value:[], defawlt: defawlt };
    for (var i=1; i<arguments.length; i+=2)
        def.value.push({ name: arguments[i], help: arguments[i+1]});
    return def;
}

function get_options(optionsdef, initial_options) {
    var options = {};

    for (var o in optionsdef)
        options[o] = get_option(o, optionsdef[o], initial_options && initial_options[o]);

    return options;
}

// Old way--going away eventually.
function add_option(name, kind, defawlt, help)
{
    if (!options)
        options = {}
    optionsdef[name] = option_def.apply(this, Array.prototype.slice.call(arguments,1));
    options[name] = get_option(name, optionsdef[name]);
}

module.exports = {
    option_def: option_def,
    get_options: get_options
};
// Copyright 2005-2011 David Caldwell <david@porkrind.org> All rights reserved.

var dom = require('./dom'), URL=dom.URL;
var Prefs = require('./prefs');

var options;
var optionsdef = {};

function get_option(name, def, initial) {
    var val = initial;

    if (name in URL.param)
        val = URL.param[name];
    else if (name in Prefs.v)
        val = Prefs.v[name];
    else if (val === undefined)
        val = def.defawlt;

    if (def.kind == "boolean" && typeof(val) == "string")
        val = val.toLowerCase() == "false" || val == "0" ? false : true;
    if (def.kind == "number" && typeof(val) == "string")
        val = parseInt(val);
    return val;
}

function option_def(kind, defawlt) {
    var def = { kind:kind, value:[], defawlt: defawlt };
    for (var i=1; i<arguments.length; i+=2)
        def.value.push({ name: arguments[i], help: arguments[i+1]});
    return def;
}

function get_options(optionsdef, initial_options) {
    var options = {};

    for (var o in optionsdef)
        options[o] = get_option(o, optionsdef[o], initial_options && initial_options[o]);

    return options;
}

// Old way--going away eventually.
function add_option(name, kind, defawlt, help)
{
    if (!options)
        options = {}
    optionsdef[name] = option_def.apply(this, Array.prototype.slice.call(arguments,1));
    options[name] = get_option(name, optionsdef[name]);
}

module.exports = {
    option_def: option_def,
    get_options: get_options
};
